export { default } from './ResellerRatingsBadge';
